import React from 'react';
import PropTypes from 'prop-types';
import { colors } from '@styles/theme';

function DeepCleanSvg(props) {
  const { fill, width, height } = props;

  let fill1 = '#262626';
  let fill2 = '#262626';
  let fill3 = '#262626';

  if (Array.isArray(fill)) {
    const [first, second, third] = fill;
    if (first) {
      fill1 = first;
    }
    if (second) {
      fill2 = second;
    }
    if (third) {
      fill3 = third;
    }
  } else if (fill) {
    fill1 = fill;
    fill2 = fill;
    fill3 = fill;
  }

  return (
    <svg width={width || 48} height={height || 48} viewBox="0 0 48 48">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="deepClean">
          <g id="Group-3">
            <polygon
              id="@bounds"
              points="0 0.00457512454 48 0.00457512454 48 47.904575 0 47.904575"
            ></polygon>
            <path
              d="M36.1666667,2.17267513 C36.8682288,2.25067794 37.4220487,2.80486341 37.5,3.50688867 L38.6753041,14.0916087 C38.8684811,15.8313491 40.1689801,17.2436744 41.8859957,17.5783788 L46.7,18.5167909 C47.5284271,18.6782794 48.0691741,19.4812078 47.9077922,20.3101818 C47.7887636,20.9215989 47.3110137,21.3996641 46.7,21.5187714 L41.8859957,22.4571835 C40.1689801,22.7918879 38.8684811,24.2042132 38.6753041,25.9439536 L37.5,36.5286736 C37.4079525,37.3576476 36.6617605,37.9549954 35.8333333,37.8628871 C35.1317712,37.7848843 34.5779513,37.2306988 34.5,36.5286736 L33.3246959,25.9439536 C33.1315189,24.2042132 31.8310199,22.7918879 30.1140043,22.4571835 L25.3,21.5187714 C24.4715729,21.3572829 23.9308259,20.5543544 24.0922078,19.7253804 C24.2112364,19.1139633 24.6889863,18.6358981 25.3,18.5167909 L30.1140043,17.5783788 C31.8310199,17.2436744 33.1315189,15.8313491 33.3246959,14.0916087 L34.5,3.50688867 C34.5920475,2.67791466 35.3382395,2.08056691 36.1666667,2.17267513 Z"
              id="shapeC"
              fill={fill1}
            ></path>
            <path
              d="M22.2586207,22.0777608 C22.893396,22.1872771 23.390556,22.6847652 23.5,23.3199596 L24.7815333,30.7577593 C24.9146129,31.5301308 25.4860055,32.1536835 26.2434669,32.3531471 L30.7,33.5266931 C31.5284271,33.7448442 32.0232703,34.5937068 31.8052632,35.4226808 C31.6629741,35.963736 31.2406983,36.3862906 30.7,36.5286736 L26.2434669,37.7022197 C25.4860055,37.9016832 24.9146129,38.525236 24.7815333,39.2976074 L23.5,46.7354071 C23.3571677,47.5643811 22.5698064,48.1205325 21.7413793,47.9776059 C21.106604,47.8680896 20.609444,47.3706015 20.5,46.7354071 L19.2184667,39.2976074 C19.0853871,38.525236 18.5139945,37.9016832 17.7565331,37.7022197 L13.3,36.5286736 C12.4715729,36.3105225 11.9767297,35.46166 12.1947368,34.6326859 C12.3370259,34.0916307 12.7593017,33.6690761 13.3,33.5266931 L17.7565331,32.3531471 C18.5139945,32.1536835 19.0853871,31.5301308 19.2184667,30.7577593 L20.5,23.3199596 C20.6428323,22.4909856 21.4301936,21.9348343 22.2586207,22.0777608 Z"
              id="shapeB"
              fill={fill2}
            ></path>
            <path
              d="M12.2102804,0.0148653052 C12.879857,0.108793149 13.4061341,0.635417719 13.5,1.30543634 L14.801961,10.5988889 C14.9204603,11.4447423 15.56236,12.1221229 16.4001719,12.2854408 L22.7,13.5134902 C23.5284271,13.6749786 24.0691741,14.4779071 23.9077922,15.3068811 C23.7887636,15.9182982 23.3110137,16.3963634 22.7,16.5154706 L15.700086,17.8799904 C15.28118,17.9616493 14.9602302,18.3003397 14.9009805,18.7232663 L13.5,28.7235244 C13.3838654,29.5524984 12.6181468,30.1303068 11.7897196,30.0140955 C11.120143,29.9201676 10.5938659,29.393543 10.5,28.7235244 L9.19803903,19.4300718 C9.07953969,18.5842185 8.43763996,17.9068379 7.59982809,17.74352 L1.3,16.5154706 C0.471572875,16.3539822 -0.0691741152,15.5510537 0.0922077922,14.7220797 C0.211236443,14.1106626 0.688986258,13.6325974 1.3,13.5134902 L7.59982809,12.2854408 C8.43763996,12.1221229 9.07953969,11.4447423 9.19803903,10.5988889 L10.5,1.30543634 C10.6161346,0.476462329 11.3818532,-0.101346005 12.2102804,0.0148653052 Z"
              id="shapeA"
              fill={fill3}
            ></path>
          </g>
        </g>
      </g>
    </svg>
  );
}

DeepCleanSvg.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.any
};

DeepCleanSvg.defaultProps = {
  fill: [colors.darkGold, colors.lightGreen, colors.gold]
};

export default DeepCleanSvg;
